import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { BrowserFrame, Chip, DemoCaption, PhoneFrame } from './shared';

// Section 10 — desktop & mobile experience. Described honestly as a
// responsive web platform (no native-app claims).
export const CompassDevices = ({ sp }) => (
  <section aria-labelledby="compass-devices-heading" data-testid="compass-devices" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="10"
        eyebrow="Work From Anywhere"
        title="Clear visibility wherever you are"
        description={sp.devicesCopy}
        testid="compass-devices-header"
      />
      <div className="mt-6 flex flex-wrap justify-center gap-2" aria-label="Available on the go">
        {(sp.devicesPoints || []).map((point) => (
          <Chip key={point}>{point}</Chip>
        ))}
      </div>
      <Reveal className="relative mt-14">
        <BrowserFrame shot={sp.shots.dashboard} label="Amden Compass — demonstration workspace" className="mx-auto max-w-4xl" />
        <div className="mt-8 flex justify-center gap-6 sm:absolute sm:-bottom-10 sm:right-4 sm:mt-0 sm:gap-4 lg:right-16">
          <PhoneFrame shot={sp.shots.healthMobile} className="w-32 sm:w-36" />
          <PhoneFrame shot={sp.shots.kpiMobile} className="w-32 sm:w-36" />
        </div>
        <DemoCaption className="sm:pb-0" />
      </Reveal>
      <p className="mx-auto mt-10 max-w-2xl text-center text-sm leading-relaxed text-slate-500">
        Compass is a responsive web platform — there is nothing to install, and it works across supported desktop, tablet and mobile browsers.
      </p>
    </div>
  </section>
);
